module.exports = __webpack_public_path__ + "img/reference-orbit-theme.6151efd9.jpg";